// extracted by mini-css-extract-plugin
export default {"mainContainer":"app_mainContainer__adcI6","contentContainer":"app_contentContainer__jjjfo"};